$(".twocol .gpvideoblock").each(function () {
    const videoWrap = $(this);
    videoButton = videoWrap.find('a.gpLocalVideo, button.gpLocalVideo');

    videoButton.on( "click", function() {
        const videoHTML = '<video class="video" autoplay controls>'+
                            '<source src="'+thisVideoSrc+'" type="video/mp4" />'+
                        '</video>'
        videoButton.replaceWith(videoHTML);
    });
});